<template>
  <div class="product-multi-select">
    <el-select
      ref="selectRef"
      popper-class="product-multi-select-popper"
      style="width: 100%"
      :size="size"
      @change="changeSelect"
      :placeholder="lastSearchText && visible ? '' : placeholder"
      collapse-tags
      :multiple="multiple"
      :clearable="multiple || clearable"
      v-model="bindValue"
      v-bind="$attrs"
      v-on="$listeners"
      :filter-method="filterProduct"
      v-loadmore="loadMoreData"
      :reserve-keyword="true"
      filterable
      @visible-change="visibleChange"
      @clear="clearSelect"
    >
      <el-checkbox
        v-if="multiple"
        class="select-all"
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选
      </el-checkbox>
      <el-option
        v-for="item in displayedOptions"
        :key="item.afid"
        :label="`${item.appName}`"
        :value="item.afid"
      >
        <div class="flex" style="justify-content: space-between">
          <div>
            <div class="title-main">{{ item.appName }}</div>
            <div :title="item.storeName" class="title-extral">
              {{ item.storeName }}
            </div>
          </div>
          <div
            style="
              color: #8393b2;
              font-size: 13px;
              margin-left: 16px;
              line-height: 40px;
              font-weight: 400;
            "
          >
            {{ item.afid }}
          </div>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getProductTableListFetch } from "@/api/api.js";
import { chunk } from "lodash";
import { removeSelectReadonly } from "@/utils/tool.js";

export default {
  props: {
    value: {
      type: [Array, String, String],
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    // 传入的接口参数
    searchParams: {
      type: Object,
      default: () => {},
    },
    // 是否默认选中第一个产品
    isDefault: {
      type: Boolean,
      default: false,
    },
    // 是否清空
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择产品",
    },
    // 下拉框接口，要求是res.data.list 格式
    apiName: {
      type: Function,
      default: getProductTableListFetch,
    },
    // 尺寸
    size: {
      type: String,
      default: "medium",
    },
  },
  data() {
    return {
      bindValue: this.value,
      allOptionsList: [],
      filterOptions: [], // 筛选后的数据
      displayedOptions: [], // 当前显示的选项
      pageIndex: 0, // 当前分段页码
      checkAll: false,
      isIndeterminate: false,
      lastSearchText: "", // 存储上一次搜索内容
      visible: false,
    };
  },

  computed: {},

  watch: {
    value: {
      handler(val) {
        this.bindValue = val;
      },
      deep: true,
    },
  },

  created() {
    this.initSelect();
  },

  methods: {
    initSelect() {
      this.apiName({
        ...this.searchParams,
        offset: 0,
        limit: 9999,
        order: "asc",
      }).then((res) => {
        if (res.code === "0000") {
          this.allOptionsList = res.products;
          this.filterOptions = res.products;
          if (this.isDefault) {
            this.bindValue = this.multiple
              ? [res.products[0].afid]
              : res.products[0].afid;
            this.$emit("update:value", this.bindValue);
          }
          this.pageIndex = 0;
          this.displayedOptions = [];
          this.loadMoreData();
        }
      });
    },
    handleCheckAllChange(val) {
      let arr = this.filterOptions.map((item) => item.afid);
      this.bindValue = val
        ? [...new Set(arr.concat(this.bindValue))]
        : this.bindValue.filter((item) => !arr.includes(item));
      this.isIndeterminate = false;
      // 点击全选
      this.$emit("update:value", this.bindValue);
      this.$emit("change");
      this.$nextTick(() => {
        this.$refs.selectRef.$el.querySelector("input").focus();
      });
    },
    changeSelect() {
      if (this.multiple) {
        let arr = this.filterOptions.map((item) => item.afid);
        const selectLength = arr.filter((item) =>
          this.bindValue.includes(item)
        ).length;
        this.checkAll = selectLength === this.filterOptions.length;
        this.isIndeterminate =
          selectLength > 0 && selectLength < this.filterOptions.length;
      }
      this.$emit("update:value", this.bindValue);
    },
    clearSelect() {
      this.lastSearchText = "";
    },
    filterProduct(value) {
      if (value) {
        this.filterOptions = this.allOptionsList.filter((item) => {
          return (
            (item.afid + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.pkg + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.packageName + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.package_name + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.dbtId + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.appName + "").toLowerCase().indexOf(value.toLowerCase()) >=
              0 ||
            (item.storeName + "").toLowerCase().indexOf(value.toLowerCase()) >=
              0
          );
        });
      } else {
        this.filterOptions = this.allOptionsList;
      }
      this.changeSelect();
      const myParentElement = document.querySelector(
        ".product-multi-select-popper"
      ); // 获取父元素
      const myChildElements = Array.from(
        myParentElement.getElementsByClassName("el-scrollbar__wrap")
      )[0];
      myChildElements.scrollTop = 0;
      this.pageIndex = 0;
      this.displayedOptions = [];
      this.loadMoreData();
    },
    visibleChange(val) {
      this.visible = val;
      this.filterOptions = this.allOptionsList;
      if (val) {
        if (this.lastSearchText !== "") {
          this.$nextTick(() => {
            this.$refs.selectRef.$el.querySelector("input").value =
              this.lastSearchText;
            this.$refs.selectRef.query = this.lastSearchText;
            this.$refs.selectRef.previousQuery = this.lastSearchText;
          });
        }
        if (this.multiple) {
          this.isIndeterminate =
            this.bindValue.length > 0 &&
            this.bindValue.length < this.filterOptions.length;
          this.checkAll = this.bindValue === this.filterOptions.length;
        }
      } else {
        this.lastSearchText = this.$refs.selectRef.$el
          .querySelector("input")
          .value?.trim();
        removeSelectReadonly(this.$refs.selectRef);
      }
      this.filterProduct(this.lastSearchText);
      this.pageIndex = 0;
      this.displayedOptions = [];
      this.loadMoreData();
    },
    sortedOptions() {
      const selectedValue = this.bindValue;
      if (this.multiple) {
        return this.filterOptions.sort((a, b) => {
          if (selectedValue.includes(a.afid)) {
            return -1;
          } else if (selectedValue.includes(b.afid)) {
            return 1;
          }
          return 0;
        });
      } else {
        return this.filterOptions.sort((a, b) => {
          if (selectedValue == a.afid) {
            return -1;
          } else if (selectedValue == b.afid) {
            return 1;
          }
          return 0;
        });
      }
    },
    loadMoreData() {
      this.sortedOptions();
      const perPageCount = 10; // 每一页的选项数
      const chunked = chunk(this.sortedOptions(), perPageCount); // 分段
      // 如果所有数据已经加载完成，则直接退出
      if (this.pageIndex >= chunked.length) {
        return;
      }
      // 加载当前分段的数据段
      this.displayedOptions = this.displayedOptions.concat(
        chunked[this.pageIndex++]
      );
    },
  },
};
</script>

<style lang="less" scoped>
.product-multi-select {
  width: 260px;
  /deep/ .el-tag.el-tag--info:first-child {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /deep/ .el-tag__close {
    margin-bottom: 0px !important;
  }
}
</style>

<style lang="less">
.product-multi-select-popper {
  position: relative;
  .el-select-dropdown__list {
    padding-top: 0px !important;
  }
  .el-select-dropdown__item {
    height: 50px !important;
    min-width: 380px;
    width: calc(100% - 0px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-top: 6px;
    padding-right: 20px !important;
    border-bottom: 1px dashed #dadad8;
    border-radius: 4px;
    margin-top: 4px;
  }
  .title-main {
    line-height: 20px;
    color: rgba(0, 0, 0, 0.85);
  }
  .title-extral {
    line-height: 20px;
    font-size: 10px;
    font-weight: 400;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;

    color: rgba(0, 0, 0, 0.45);
  }
  .selected {
    background-color: #f5f7fa !important;
    .title-main {
      color: #2a56e3;
    }
  }
  .select-all {
    width: calc(100% - 0px) !important;
    position: sticky;
    top: 0;
    text-align: end;
    background: white;
    width: 100%;
    z-index: 99;
    height: 40px;
    line-height: 42px;
    .el-checkbox__label {
      margin-right: 12px;
    }
  }
}
</style>
